module.exports = __webpack_public_path__ + "static/media/partners_pfizer.02e2a213.png";